/** @file Half-width of bone.split's weight band: the limb's thickness at the cut, clamped to the bone. */

/** The band is never narrower than this share of the bone. */
const MIN_BAND = 0.05;
/** Points this close to the cut (share of the bone) measure the limb's thickness there. */
const NEAR = 0.15;

/**
 * For points [x, y, …] in the split bone's setup space (x along the bone): the limb's thickness 2·max |y| over the
 * points within 0.15·length of the cut (over all points when none is), clamped to [0.05·length, ½·min(cut, length − cut)].
 */
export function splitBand(points: readonly number[], cut: number, length: number): number {
  let near = -1;
  let all = 0;
  for (let i = 0; i + 1 < points.length; i += 2) {
    const y = Math.abs(points[i + 1] ?? 0);
    all = Math.max(all, y);
    if (Math.abs((points[i] ?? 0) - cut) <= NEAR * length) near = Math.max(near, y);
  }
  const thickness = 2 * (near >= 0 ? near : all);
  return Math.min(Math.max(thickness, MIN_BAND * length), 0.5 * Math.min(cut, length - cut));
}
